import React from 'react';
import Icon from '../../common/icons';

// The card the test chat shows when the server turned answers down for a reason that isn't
// the connection (F21): what happened and the one thing to do next. Words: refusals.js.

const tx = (lang, en, fil) => (lang === 'fil' ? fil : en);

/** "18", "18 and 19", "18, 19 and 20", "18, 19, 20 and 2 more" */
const questionList = (numbers, lang) => {
  const and = tx(lang, 'and', 'at');
  if (numbers.length <= 1) return String(numbers[0] || '');
  if (numbers.length <= 3) return `${numbers.slice(0, -1).join(', ')} ${and} ${numbers[numbers.length - 1]}`;
  const more = numbers.length - 3;
  return `${numbers.slice(0, 3).join(', ')} ${and} ${more} ${tx(lang, 'more', 'pa')}`;
};

/**
 * "One answer didn't reach us": the questions (0-based) still missing after every answer was
 * sent again. The button takes the student to the first one.
 */
export const repairCopy = (missing, lang = 'en') => {
  const numbers = missing.map((i) => i + 1);
  const one = numbers.length === 1;
  return {
    icon: 'info',
    tone: 'good',
    title: one
      ? tx(lang, "One answer didn't reach us", 'May isang sagot na hindi umabot sa amin')
      : tx(lang, `${numbers.length} answers didn't reach us`, `${numbers.length} sagot ang hindi umabot sa amin`),
    text: one
      ? tx(lang, `Please answer question ${numbers[0]} again. Then your test is done.`, `Pakisagot ulit ang tanong ${numbers[0]}. Pagkatapos, tapos na ang test mo.`)
      : tx(lang, `Please answer questions ${questionList(numbers, lang)} again. Then your test is done.`, `Pakisagot ulit ang mga tanong ${questionList(numbers, lang)}. Pagkatapos, tapos na ang test mo.`),
    action: { kind: 'repair', label: tx(lang, `Answer question ${numbers[0]}`, `Sagutin ang tanong ${numbers[0]}`) },
  };
};

const RefusalCard = ({ copy }) => {
  if (!copy) return null;
  return (
    <div className={`ts-card ts-refusal${copy.tone === 'warn' ? ' is-warn' : ''}`} role="status">
      <div className="ts-card-top">
        <span className="ts-tile">
          <Icon name={copy.icon || 'info'} size={20} />
        </span>
        <div>
          <h3 className="ts-card-title">{copy.title}</h3>
        </div>
      </div>
      <div className="ts-card-body">
        <p>{copy.text}</p>
      </div>
    </div>
  );
};

export default RefusalCard;
